/** Statistics endpoints may return a bare array or `{ data: T[] }` (MSW / legacy wrappers). */
export const normalizeArrayResponse = <T>(value: T[] | { data: T[] }): T[] => {
  if (Array.isArray(value)) {
    return value;
  }
  if (
    value != null &&
    typeof value === "object" &&
    "data" in value &&
    Array.isArray((value as { data: unknown }).data)
  ) {
    return value.data;
  }
  return [];
};
